<template>
  <dd-container class="flex-col flex-stretch">

      <div class="flex-row flex-stretch">

          <div class="pr-lg" style="flex: 0.15">

              <div class="flex-row align-items-end gap-xs mb-xs">
                <h1>Email</h1>
                <p>Account</p>
              </div>

              <div class="mt-sx">
                  <dd-button class="width-stretch justify-content-end mb-sm">
                      info@ddat.nl
                  </dd-button>
                  <dd-button class="width-stretch justify-content-end mb-sm" color="link">
                      noreply@ddat.nl
                  </dd-button>
                  <dd-button class="width-stretch justify-content-end mb-sm" color="link">
                      adviseur@ddat.nl
                  </dd-button>
                  <dd-button class="width-stretch justify-content-end mb-sm" color="link">
                      adviseur@ddat.nl
                  </dd-button>
              </div>

          </div>

          <div class="flex-col gap-lg" style="flex: 0.85">

              <dd-card>
                  <div class="flex-row justify-content-between">
                      <div class="flex-row gap-md">
                          <dd-input placeholder="Zoeken in adres of onderwerk" />
                          <dd-date-picker value="12-12-2023"/>
                      </div>
                      <div class="flex-row gap-md">
                          <dd-multi-switch group-name="email_verwerkt" @input="selectEmailVerwerkMode">
                              <dd-multi-switch-item title="Onverwerkte e-mails" :value="0" active/>
                              <dd-multi-switch-item title="Verwerkte e-mails" :value="1"/>
                          </dd-multi-switch>
                          <dd-icon-button icon="refresh" title="refresh inbox"></dd-icon-button>
                      </div>
                  </div>
              </dd-card>

              <dd-header-card header="Een titel voor deze card" collapsible>
                <template v-slot:subtitle>
                  <p class="m-0 color-primary font-light font-size-sm">Een fancy sub title</p>
                </template>
                <p class="m-0">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.</p>
              </dd-header-card>

              <dd-card>
                <dd-collapse>
                  <a-collapse-panel key="1" header="This is panel header 1">
                    <p class="m-0">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.</p>
                  </a-collapse-panel>
                  <a-collapse-panel key="2" header="This is panel header 2">
                    <p class="m-0">Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.</p>
                  </a-collapse-panel>
                </dd-collapse>
              </dd-card>

              <dd-card
                  :wide-content="true"
                  class="flex-stretch justify-content-start"
              >

                  <dd-main-table
                    :headers="[{title: 'afzender', key: 'afzender'}, {title: 'onderwerp', key: 'onderwerp'}, {title: 'verzend datum', key: 'verzend_datum'}]"
                    :rows="[
                        {'afzender': 'ivanhermse@gmail.com', 'onderwerp': 'Wat doe je daar?', 'verzend_datum': '21-06-2023'},
                        {'afzender': 'ivanhermse2@gmail.com', 'onderwerp': 'Wat doe je zo?', 'verzend_datum': '21-07-2023'}
                    ]"
                  >
                      <template v-slot:actions="{ row }">
                          <dd-icon-button icon="link-variant" size="md"/>
                      </template>
                  </dd-main-table>

              </dd-card>
          </div>

      </div>

  </dd-container>
</template>

<script>

export default {
  name: "TestPage.vue",
  data() {
    return {}
  },
    methods: {
        selectEmailVerwerkMode(e){
            console.log(e)
        }
    }
}

</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
